import React from "react";

// FLF Draw: logo da tela inicial. A imagem fica em /public/flf-logo-black.png
// (no tema escuro ela e invertida por CSS em flf-draw.scss).
export const FlfDrawLogo = () => {
  return (
    <div className="flf-draw-logo" role="img" aria-label="FLF Draw">
      <img
        className="flf-draw-logo__mark"
        src="/flf-logo-black.png"
        alt=""
        draggable={false}
      />
      <span className="flf-draw-logo__word" aria-hidden="true">
        DRAW
      </span>
    </div>
  );
};
